import * as moment from 'moment';
import { PwForecastPrecip } from './pw-forecast-precip.model';
import { PwValueUnit } from './pw-value-unit.model';
import { PwWind } from './pw-wind.model';

export class PwForecastData {

    constructor(json: any) {
        if (json) {
            Object.assign(this, json);

            if (json.precipitation) this.precipitation = new PwForecastPrecip(this.precipitation);
            if (json.observationTime) this.observationTime = moment.utc(json.observationTime).toDate();
            if (json.humidity) this.humidity = new PwValueUnit(this.humidity);
            if (json.dewPoint) this.dewPoint = new PwValueUnit(this.dewPoint);
            if (json.wind) this.wind = new PwWind(this.wind);
        }
    }

    precipitation: PwForecastPrecip;
    observationTime: Date;
    weatherConditions: string;
    humidity: PwValueUnit;
    dewPoint: PwValueUnit;
    wind: PwWind;
}
